













import {
  defineComponent,
  PropType,
  reactive,
  toRefs
} from "@vue/composition-api";
import "@/components/icons";
import SearchTextField from "@/components/Atoms/Forms/SearchTextField/index.vue";
import { Props } from "./types";

export default defineComponent({
  name: "FileSearchField",
  components: {
    SearchTextField
  },
  model: {
    prop: "inputText",
    event: "input"
  },
  props: {
    searchText: {
      type: String as PropType<Props["searchText"]>,
      required: true
    }
  },
  setup(props, { emit }) {
    const state = reactive({
      inputText: props.searchText
    });

    const handleEnter = () => {
      emit("search", state.inputText);
    };

    const handleClear = () => {
      state.inputText = "";
    };

    return {
      ...toRefs(state),
      handleEnter,
      handleClear
    };
  }
});
